import { render, staticRenderFns } from "./CreateNewPresetButton.vue?vue&type=template&id=380453f3&scoped=true&"
import script from "./CreateNewPresetButton.vue?vue&type=script&lang=ts&"
export * from "./CreateNewPresetButton.vue?vue&type=script&lang=ts&"
import style0 from "./CreateNewPresetButton.vue?vue&type=style&index=0&id=380453f3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380453f3",
  null
  
)

export default component.exports